import { API_URLS } from "../constants";
import { postRequest, putRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { STORE } = API_URLS;

//Getting Paginated Brand Locations
const getBrandLocations = (body) => {
  return postRequest(STORE.GET, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Updating Brand Locations
const updateBrandLocations = (body) => {
  return putRequest(STORE.UPDATE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Exporting functions for other files
export const googleSocialLinkService = {
  getBrandLocations,
  updateBrandLocations,
};
